var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconplusbig = function SvgIconplusbig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0v7h7v1H8v7H7V7.999L0 8V7l7-.001V0h1z",
    fill: "#1F140F",
    fillRule: "evenodd"
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDE1IDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNTkuMSAoODYxNDQpIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPg0KICAgIDx0aXRsZT5pY29ucGx1c2JpZzwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGcgaWQ9Imljb25wbHVzYmlnIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPHBhdGggZD0iTTgsMCBMOCw3IEwxNSw3IEwxNSw4IEw4LDggTDgsMTUgTDcsMTUgTDcsNy45OTkgTDQuNDQwODkyMWUtMTUsOCBMNC41MDIxMjQ0NGUtMTUsNyBMNyw2Ljk5OSBMNywwIEw4LDAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjMUYxNDBGIj48L3BhdGg+DQogICAgPC9nPg0KPC9zdmc+";
export { SvgIconplusbig as ReactComponent };